module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"live":"Live events"},"fr":{"live":"Evènements en direct"}}')
  delete Component.options._Ctor
}
